import { useEffect } from 'react';

/** Sets the browser tab title to "<page> · Checkover Admin" while mounted. */
export function usePageTitle(title?: string) {
  useEffect(() => {
    const base = 'Checkover Admin';
    document.title = title ? `${title} · ${base}` : base;
    return () => {
      document.title = base;
    };
  }, [title]);
}
